<template>
  <div>
    <BListFilter
      v-model="form"
      label="Поиск по названию"
      :skeleton="skeleton"
      dense
      @change="onChangeDebounced"
    />

    <v-row dense>
      <v-col :cols="!skeleton && 'auto'">
        <BAutocompleteCommon
          v-model="form.owner"
          $type="user"
          :skeleton="skeleton"
          label="Владелец"
          placeholder="Начните вводить..."
          @input="onChangeDebounced"
        />
      </v-col>

      <v-col cols="6">
        <BAutocompleteCommon
          v-model="form.tags"
          $type="file-tag"
          :skeleton="skeleton"
          placeholder="Начните вводить..."
          multiple
          @input="onChangeDebounced"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BListFilter, { createDefaultData } from '@/components/forms/BListFilter.vue'
import BAutocompleteCommon from '@/components/forms/BAutocompleteCommon.vue'


const createDefaultDataFiles = () => ({
  ...createDefaultData(),
  owner: null,
  tags: [],
})

export default {
  name: 'FilesFilter',
  components: {
    BListFilter,
    BAutocompleteCommon,
  },
  extends: BListFilter,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      default: createDefaultDataFiles,
    },
  },
}
</script>
